import { RouterProvider, createBrowserRouter } from "react-router-dom";
import AppErrorBoundary from "@/components/app/AppErrorBoundary";
import { route } from "./route";
import Sidebar from "@/components/dashboard/Sidebar";
import RouteOutlet from "./RouteOutlet";

const router = createBrowserRouter([
  {
    path: "/",
    lazy: () => route(import("../components/login/Login")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/login",
    lazy: () => route(import("../components/login/Login")),
    ErrorBoundary: AppErrorBoundary,
  },
  // {
  //   path: "/ref",
  //   lazy: () => route(import("../components/login/Login")),
  //   ErrorBoundary: AppErrorBoundary,
  // },
  {
    path: "/register",
    lazy: () => route(import("../components/register/Register")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/ref/:code",
    lazy: () => route(import("../components/referral/ReferralRedirect")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/forgot-password",
    lazy: () => route(import("../components/forgot-password")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/reset-password",
    lazy: () => route(import("../components/reset-password")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/payment-link/:paymentLinkId",
    lazy: () => route(import("../components/paymentLink/PaymentLink")),
    ErrorBoundary: AppErrorBoundary,
  },
  {
    path: "/dashboard",
    element: <RouteOutlet />,
    ErrorBoundary: AppErrorBoundary,
    children: [
      {
        path: "",
        element: <Sidebar />,
        children: [
          {
            index: true,
            lazy: () => route(import("../components/dashboard/Home")),
          },
          {
            path: "home",
            lazy: () => route(import("../components/dashboard/Home")),
          },
          {
            path: "balances",
            // lazy: () => route(import("../components/")),
          },
          {
            path: "customers",
            lazy: () => route(import("../components/dashboard/customers/Customers")),
            ErrorBoundary: AppErrorBoundary,
          },
          {
            path: "config",
            lazy: () => route(import("../components/withdraw/Withdraw")),
          },
          {
            path: "apis",
            lazy: () => route(import("../components/dashboard/apis/Apis")),
            ErrorBoundary: AppErrorBoundary,
          },
          // {
          //   path: "transactions/:id",
          //   lazy: () => route(import("../components/transaction/TransactionDetails")),
          // }
          {
            path: "withdraw",
            lazy: () => route(import("../components/withdraw/WithdrawScreen")),
            ErrorBoundary: AppErrorBoundary,
          },
          {
            path: "affiliate",
            lazy: () =>
              route(import("../components/dashboard/affiliate/Affiliate")),
            ErrorBoundary: AppErrorBoundary,
          },
          {
            path: "merchant",
            lazy: () =>
              route(import("../components/dashboard/merchant/MerchantMode")),
            ErrorBoundary: AppErrorBoundary,
          },
          {
            path: "qrcode",
            lazy: () =>
              route(import("../components/dashboard/qrcode/CreateQRCode")),
            ErrorBoundary: AppErrorBoundary,
          },
          {
            path: "payment-links",
            lazy: () =>
              route(import("../components/dashboard/paymentLinks/PaymentLinks")),
            ErrorBoundary: AppErrorBoundary,
          },
          {
            path: "transactions",
            lazy: () =>
              route(import("../components/dashboard/transactions/Transactions")),
            ErrorBoundary: AppErrorBoundary,
          },
          {
            path: "settings",
            lazy: () =>
              route(import("../components/dashboard/settings/Settings")),
            ErrorBoundary: AppErrorBoundary,
          },
        ],
      },
    ],
  },
]);

const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
